import { X } from '@ui/components/icons';
import { HLine, VLine } from '@ui/components/Line';
import { MassiveTokenSearch } from '@ui/features/MassiveToken/components/MassiveTokenSelectTable/MassiveTokenSearch';
import { MassiveTokenSelectTable } from '@ui/features/MassiveToken/components/MassiveTokenSelectTable/MassiveTokenSelectTable';
import { MassiveTokenTabs } from '@ui/features/MassiveToken/components/MassiveTokenSelectTable/MassiveTokenTabs';
import { Popover } from '@ui/lib/park/ui/popover';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { Box, Flex, HStack, VStack } from 'styled-system/jsx';

export const PairPopover = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();

  return (
    <Popover.Root
      positioning={{
        placement: 'top-end',
        flip: true,
        fitViewport: true,
        slide: true,
      }}
      onOpenChange={(v) => setOpen(v.open)}
      closeOnInteractOutside={true}
      open={open}
    >
      <Popover.Trigger asChild>{children}</Popover.Trigger>
      {/* dim the terminal behind the selector so the eye locks onto it
          (below zIndex.popover=1110 so the panel stays on top) */}
      {open && (
        <Box
          position="fixed"
          inset={0}
          bg="rgba(0, 0, 0, 0.55)"
          zIndex="sticky"
          data-cy="PairSelectorBackdrop"
        />
      )}
      <Popover.Positioner>
        <Popover.Content
          p="0"
          minW="850px"
          display="flex"
          flexDir="column"
          maxH="82vh"
          borderRadius="4px"
        >
          <Box p="12px" pb="0" flexShrink={0}>
            <MassiveTokenSearch
              fieldRootProps={{
                padding: '0',
                paddingLeft: '12px',
              }}
              fieldInputProps={{
                textStyle: 'text.small',
                fontWeight: 'bold',
              }}
              w="full"
              bg="black.background"
              display={{
                base: 'none',
                desktop: 'block',
              }}
            />
            <MassiveTokenTabs />
          </Box>
          <Box pt={0} flex={1} minH={0} display="flex" flexDir="column">
            {open && (
              <MassiveTokenSelectTable
                onItemClickCallBack={() => {
                  setOpen(false);
                }}
              />
            )}
          </Box>
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  );
};
